export default function composeMessaging(messageType, messagingId, messageId, opts = {}) {
  const { defaultMessage = '', values = {}, ...rest } = opts;

  return {
    [messagingId]: {
      message: {
        type: messageType,
        id: messageId,
        defaultMessage,
        values
      },
      ...rest
    }
  };
}
